import i18n from "@/i18n/config"
import type { Capacity } from "@/queries/models"

import type { ProductStatusInfo } from "../useProductStatus"

const getBlockedStatus = (
  isSelectable: boolean
): ProductStatusInfo | undefined => {
  if (!isSelectable) {
    return {
      status: "blocked",
      statusDescription: i18n.t("notAvailable"),
    }
  }
}

const getCapacityStatus = (
  capacityGroupId: string | undefined,
  capacities: Capacity[] | undefined
): ProductStatusInfo | undefined => {
  if (!capacityGroupId || !capacities?.length) return undefined

  const capacity = capacities.find((c) => c.id === capacityGroupId)
  if (!capacity) return undefined

  const status = capacity.isOutOfStock
    ? "out-of-stock"
    : capacity.isLowStock
      ? "low-stock"
      : "limited"

  return {
    status,
    statusDescription: capacity.stockStatusDescription,
    quantityOnHand: capacity.quantityOnHand,
  }
}

export { getBlockedStatus, getCapacityStatus }
